export interface HirarchyState {
    hirarchy: Array<HirarchyLevel>;
}

export interface HirarchyLevel {
    id: string;
    name: string;
    parent?: string;
}

export default {
    namespaced: true,
    state: (): HirarchyState => ({
        hirarchy: [],
    }),
    getters: {
        getFormatedHirarchy(state, getters) {
            return formatHirarchy(state.hirarchy, []);
        },
        getFormatedHirarchyPopulated(state, getters, rootState) {
            return [
                ...formatHirarchy(state.hirarchy, rootState.gateway.gateways),
                ...rootState.gateway.gateways
                    .filter((gateway) => state.hirarchy.find((item) => item.id == gateway.hirarchy) == undefined)
                    .map((item) => ({
                        id: item.id,
                        name: formatGatewayName(item.number),
                        display_name: item.name,
                        status: item.status,
                        gateway: true,
                        hirarchy: item.hirarchy,
                    })),
            ];
        },
    },
    mutations: {
        setHirarchy(state, value) {
            state.hirarchy = value;
        },
    },
    actions: {
        fetchHirarchy(state) {
            this._vm.axios
                .get("/hirarchy")
                .then((res) => state.commit("setHirarchy", res.data))
                .catch(() =>
                    state.commit("ui/logMessage", { logLevel: 0, message: "Die Hierarchie Daten konnten nicht geladen werden." }, { root: true })
                );
        },
        addHirarchy(state, { name, parent }) {
            this._vm.axios
                .post("/hirarchy", { name, parent })
                .then(() => {
                    state.dispatch("fetchHirarchy");
                    state.commit("ui/logMessage", { logLevel: 4, message: `Gruppe "${name}" hinzugefügt.` }, { root: true });
                })
                .catch(() => {
                    state.commit("ui/logMessage", { logLevel: 0, message: `Gruppe "${name}" konnte nicht hinzugefüht werden.` }, { root: true });
                });
        },
        moveHirarchy(state, { from, to }) {
            this._vm.axios
                .put("/hirarchy/" + from.id, { name: from.name, parent: to.id })
                .then(() => {
                    state.dispatch("fetchHirarchy");
                    state.commit(
                        "ui/logMessage",
                        {
                            logLevel: 4,
                            message: `Gruppe "${from.name}" nach "${to.name}" verschoben.`,
                        },
                        { root: true }
                    );
                })
                .catch(() => {
                    state.commit("ui/logMessage", { logLevel: 0, message: `Gruppe "${from.name}" konnte nicht verschoben werden.` }, { root: true });
                });
        },
        moveGateway(state, { gateway, group }) {
            this._vm.axios
                .put("/gateway/" + gateway.id + "/hirarchy/", { hirarchy: group.id })
                .then(() => {
                    state.dispatch("gateway/fetchGateways", null, { root: true });
                    state.commit(
                        "ui/logMessage",
                        {
                            logLevel: 4,
                            message: `Gateway "${gateway.name}" nach "${group.name}" verschoben.`,
                        },
                        { root: true }
                    );
                })
                .catch(() => {
                    state.commit(
                        "ui/logMessage",
                        { logLevel: 0, message: `Gateway "${gateway.name}" konnte nicht verschoben werden.` },
                        { root: true }
                    );
                });
        },
        removeHirarchy(state, group) {
            let error = false;
            for (const children of group.children) {
                this._vm.axios.put("/hirarchy/" + children.id, { name: children.name, parent: null }).catch(() => {
                    state.commit("ui/logMessage", { logLevel: 1, message: `Fehler beim verschieben der Gruppe "${children.name}".` }, { root: true });
                    error = true;
                });
            }
            if (!error)
                this._vm.axios
                    .delete("/hirarchy/" + group.id)
                    .then(() => {
                        state.dispatch("fetchHirarchy");
                        state.commit("ui/logMessage", { logLevel: 4, message: `Gruppe "${group.name}" entfernt.` }, { root: true });
                    })
                    .catch(() => {
                        state.commit(
                            "ui/logMessage",
                            { logLevel: 0, message: `Gruppe "${group.name}" konnte nicht entfernt werden.` },
                            { root: true }
                        );
                    });
            else {
                state.commit("ui/logMessage", { logLevel: 0, message: `Gruppe "${group.name}" konnte nicht entfernt werden.` }, { root: true });
            }
        },
    },
    modules: {},
};

function formatHirarchy(data, gateways, parent?) {
    const output = [];
    for (const entry of data.filter((entry) => entry.parent == parent))
        output.push({
            id: entry.id,
            name: entry.name,
            children: [
                ...formatHirarchy(data, gateways, entry.id),
                ...gateways
                    .filter((gateway) => gateway.hirarchy == entry.id)
                    .map((item) => ({
                        id: item.id,
                        name: formatGatewayName(item.number),
                        display_name: item.name,
                        status: item.status,
                        gateway: true,
                        hirarchy: item.hirarchy,
                    })),
            ],
        });
    return output;
}

function formatGatewayName(number) {
    return "DS-Gateway-" + number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
}
